const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'tags',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.companies" */ '@/views/Tags'),
  },
  meta: {
    breadcrumb: {
      label: 'Tags',
    },
  },
  children: [
    {
      path: '',
      name: 'tags-listing',
      component: () => import(/* webpackChunkName: "module.companies.list" */ '@/modules/Tags/List'),
      meta: {
        breadcrumb: {
          label: 'Tags',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'tags-edit',
      component: () => import(/* webpackChunkName: "module.companies.edition" */ '@/modules/Tags/Edition'),
      meta: {
        breadcrumb: {
          parent: 'tags-listing',
          label: 'Edit Tag',
        },
      },
    },
    {
      path: 'create',
      name: 'tags-create',
      component: () => import(/* webpackChunkName: "module.companies.edition" */ '@/modules/Tags/Edition'),
      meta: {
        breadcrumb: {
          parent: 'tags-listing',
          label: 'Create Tag',
        },
      },
    },
  ],
};
